#import "./assignmentProposalListFields.fragment.graphql"

# The user's own proposals of a link with their change summary, for the proposals Drawer.
query assignmentProposals($scenarioId: ID!, $originId: ID!, $linkId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    assignmentProposals(linkId: $linkId) {
      errorCode
      proposals {
        ...ProposalListFields
        rejectionReason
        __typename
      }
      __typename
    }
    __typename
  }
}
